"use strict";

import {Component, NgModule} from "@angular/core";
import {TreemapPageComponent} from "./treemap-page.component";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ModalDialogModule} from "../../components/modal-dialog/modal-dialog.module";
import {CommonModule} from "@angular/common";
import {DropdownModule} from "../../components/dropdown-new/dropdown.module";
import {PipesModule} from "../../common/pipes/pipes.module";
import {RatingModule} from "../../components/rating/rating.module";
import {RatingOrPredictionModule} from "../../components/rating-or-prediction/rating-or-prediction.module";
import {YoutubeModule} from "../../components/youtube/youtube.module";
import {UIRouterModule} from "@uirouter/angular";
import {ExternalRecsModule} from "../externalrecs/external-recs.module";
import {AngularMyDatePickerModule} from "angular-mydatepicker";
import { InteractiveProfileService } from "./interactive_profile.service";

export const treemapPage = {
    states: [
        {
            name: "base.treemapPage",
            url: "/treemapPage",
            component: TreemapPageComponent
        }
    ]
};

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ModalDialogModule,
        CommonModule,
        DropdownModule,
        ModalDialogModule,
        PipesModule,
        RatingModule,
        RatingOrPredictionModule,
        YoutubeModule,
        UIRouterModule.forChild(treemapPage),
        ExternalRecsModule,
        ReactiveFormsModule,
        AngularMyDatePickerModule
    ],
    exports: [
    ],
    declarations: [
        TreemapPageComponent
    ],
    entryComponents: [
        TreemapPageComponent
    ],
    providers : [InteractiveProfileService]
    // providers: []
})

export class TreemapPageModule {
}